import React from 'react';
import { connect } from 'react-redux';

import { Button, Form, SidebarContent } from 'components';

import { setSidebar } from 'redux/reducers/app';
import * as giftcardsActions from 'redux/reducers/giftcards';

import styles from './styles.scss';

@connect(
  state => ({
    checking: state.getIn(['giftcards', 'checking'], false),
    invalid: state.getIn(['giftcards', 'invalid']),
    sidebarParams: state.getIn(['app', 'sidebarParams']),
  }),
  {
    setSidebar,
    check: giftcardsActions.check,
  }
)
export default class Giftcard extends React.PureComponent {
  constructor(props, context) {
    super(props, context);

    this.state = {
      code: props.sidebarParams.code || null,
    };
  }

  check = e => {
    e.preventDefault();

    const { code } = this.state;
    const { check } = this.props;

    check(code);
  };

  onChange = e => {
    const input = e.currentTarget;

    this.setState({
      [input.name]: input.value,
    });
  };

  toLogin = () => {
    this.props.setSidebar('login');
  };

  render() {
    const { code } = this.state;
    const { invalid, checking } = this.props;

    const isInvalid = invalid.indexOf(code) > -1;

    return (
      <SidebarContent title={kroostApp.strings.cachedVoucherTitle}>
        <p className={styles.notes}>{kroostApp.strings.voucherIntro}</p>

        <form method="POST" onSubmit={this.check}>
          <Form.Row>
            <Form.Input
              name="code"
              type="text"
              label={kroostApp.strings.personalGiftCodeLabel}
              placeholder="xxxx-xxxx-xxxx"
              onChange={this.onChange}
              value={code}
            />
          </Form.Row>

          {isInvalid ? <Form.Error>{kroostApp.strings.voucherInvalid}</Form.Error> : null}

          <Form.Row className={styles.actions}>
            <Button cta type="submit" className={styles.submit} disabled={!code || checking} onClick={this.check}>
              {checking ? kroostApp.strings.checking : kroostApp.strings.cash}
            </Button>
          </Form.Row>

          <Form.Row className={styles.actions}>
            <Button secondary className={styles.createAccount} onClick={this.toLogin}>
              {kroostApp.strings.toLogin}
            </Button>
          </Form.Row>
        </form>
      </SidebarContent>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/giftcard/index.js